import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { TextureBackground } from '@sorare/core/src/atoms/ui/TextureBackground';
import { OnboardingButton } from '@sorare/core/src/components/onboarding/OnboardingButton';
import {
  FOOTBALL_ONBOARDING_SELECT_COMPETITION,
  NBA_ONBOARDING_CHOOSE_TEAM,
} from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { glossary } from '@sorare/core/src/lib/glossary';

import { CommonMode } from '../CommonMode';

const StyledTextureBackground = styled(TextureBackground)`
  position: absolute;
  inset: 0;
`;

export const StartCommonGame = () => {
  const navigate = useNavigate();
  const { sport } = useSportContext();

  return (
    <>
      <StyledTextureBackground
        background="wave1"
        color="var(--c-blue-400)"
        mode="dark"
      />
      <CommonMode
        hideSelect
        selected
        onSelect={() => {
          navigate(
            sport === Sport.FOOTBALL
              ? FOOTBALL_ONBOARDING_SELECT_COMPETITION
              : NBA_ONBOARDING_CHOOSE_TEAM
          );
        }}
      >
        <Vertical center>
          <OnboardingButton color="secondary" size="medium" asSpan>
            <FormattedMessage {...glossary.playNow} />
          </OnboardingButton>
        </Vertical>
      </CommonMode>
    </>
  );
};
